module.exports = __webpack_public_path__ + "img/logoopjgnovo.0c1c85d9.png";